<template>
    <div>
        <card-header title="Fax & Docs" icon="fa-fax"/>

        <card-toolbar>
            <b-tooltip label="Upload PDF">
                <button class="icon-only" @click="triggerUpload" :disabled="uploading">
                    <i class="far" :class="uploading ? 'fa-spinner fa-spin' : 'fa-upload'"></i>
                </button>
            </b-tooltip>
            <input type="file" ref="fileInput" accept="application/pdf" style="display:none" @change="handleUpload"/>
        </card-toolbar>

        <card-body toolbar>
            <card-list>
                <container-list-item no-border>
                    <data-row title="From">
                        <b-input type="date" v-model="dateFrom" size="is-small" expanded @input="reload"/>
                    </data-row>
                    <data-row title="To">
                        <b-input type="date" v-model="dateTo" size="is-small" expanded @input="reload"/>
                    </data-row>
                    <data-row title="Status">
                        <b-field>
                            <b-radio-button v-model="filterProcessed" :native-value="null" size="is-small">All</b-radio-button>
                            <b-radio-button v-model="filterProcessed" native-value="pending" size="is-small">Unprocessed</b-radio-button>
                            <b-radio-button v-model="filterProcessed" native-value="only" size="is-small">Processed</b-radio-button>
                        </b-field>
                    </data-row>
                </container-list-item>

                <subheader-list-item
                    title="Documents"
                    icon="fa-file-pdf"
                    :badge="faxes.length"/>

                <fax-tile v-for="fax in faxes" :key="fax.id" :fax="fax"
                    :active="isActive(fax.id)"
                    @click="$openCard('fax-detail', {faxId: fax.id}, card)"/>

                <container-list-item v-if="!loading && faxes.length === 0" padded>
                    <span class="has-text-grey is-size-7">No faxes in this date range.</span>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";
    import FaxTile from "./FaxTile";
    import {client as http} from '@/http_client';
    import moment from 'moment';

    export default {
        components: {
            CardHeader, CardBody, CardList, CardToolbar,
            SubheaderListItem, ContainerListItem, DataRow,
            FaxTile
        },
        props: ['card', 'child', 'props'],
        data() {
            return {
                faxes: [],
                loading: false,
                uploading: false,
                dateFrom: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                dateTo: moment().format('YYYY-MM-DD'),
                filterProcessed: null
            };
        },
        watch: {
            filterProcessed() { this.reload(); }
        },
        mounted() {
            this.reload();
        },
        methods: {
            reload() {
                this.loading = true;
                let params = `from=${this.dateFrom}&to=${this.dateTo}`;
                if (this.filterProcessed) params += `&processed=${this.filterProcessed}`;
                http.get(`faxes?${params}`, {force: true}).then(response => {
                    this.faxes = response.data || [];
                }).catch(err => {
                    console.log(err);
                    this.$notify('error', 'Faxes', 'Failed to load.');
                }).finally(() => {
                    this.loading = false;
                });
            },
            isActive(faxId) {
                return this.child
                    && this.child.definition.component === 'fax-detail'
                    && parseInt(this.child.props.faxId) === faxId;
            },
            triggerUpload() {
                this.$refs.fileInput.value = '';
                this.$refs.fileInput.click();
            },
            handleUpload(event) {
                const file = event.target.files && event.target.files[0];
                if (!file) return;
                if (!file.name.toLowerCase().endsWith('.pdf')) {
                    this.$notify('error', 'Upload', 'PDFs only.');
                    return;
                }
                this.uploading = true;
                const form = new FormData();
                form.append('file', file);
                http.post('faxes/upload', form, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(response => {
                    this.$notify('success', 'Upload', `Uploaded ${file.name}.`);
                    const fax = response.data;
                    this.reload();
                    if (fax && fax.id) {
                        this.$openCard('fax-detail', {faxId: fax.id}, this.card);
                    }
                }).catch(err => {
                    console.log(err);
                    const msg = (err.response && err.response.data && err.response.data.error) || 'Upload failed.';
                    this.$notify('error', 'Upload', msg);
                }).finally(() => {
                    this.uploading = false;
                });
            }
        }
    };
</script>
